angular
  .module('workflow')

  .factory('WorkflowBillingDataConfirm', [
    'Crud',

    function(Crud) {
      'use strict';

      class WorkflowBillingDataConfirm extends Crud {
        constructor(id) {
          super(null, '@@apiUrl' + '/send-request' + `/${id}`, { id: '@id' });
        }
      }
      return WorkflowBillingDataConfirm;
    }
  ]);
